export const PENDING_USER_ID_QUERY_PARAM: string = 'pendingUserId';
export const PENDING_DISPLAY_NAME_QUERY_PARAM: string = 'pendingDisplayName';
